/**
 * Objects emoji category with searchable keywords
 */
export const objects = {
  name: 'Objects',
  icon: '💡',
  emojis: [
    { emoji: '⌚', keywords: ['watch', 'time', 'clock', 'wrist', 'accessory'] },
    { emoji: '📱', keywords: ['phone', 'mobile', 'cell', 'smartphone', 'iphone'] },
    { emoji: '📲', keywords: ['phone', 'arrow', 'call', 'mobile', 'incoming'] },
    { emoji: '💻', keywords: ['laptop', 'computer', 'pc', 'macbook', 'work'] },
    { emoji: '⌨️', keywords: ['keyboard', 'type', 'computer', 'input', 'keys'] },
    { emoji: '🖥️', keywords: ['desktop', 'computer', 'monitor', 'screen', 'pc'] },
    { emoji: '🖨️', keywords: ['printer', 'print', 'paper', 'office', 'document'] },
    { emoji: '🖱️', keywords: ['mouse', 'computer', 'click', 'cursor', 'pointer'] },
    { emoji: '🖲️', keywords: ['trackball', 'computer', 'input', 'control', 'device'] },
    { emoji: '💽', keywords: ['minidisc', 'disk', 'data', 'storage', 'computer'] },
    { emoji: '💾', keywords: ['floppy', 'disk', 'save', 'storage', 'retro'] },
    { emoji: '💿', keywords: ['cd', 'disc', 'dvd', 'music', 'data'] },
    { emoji: '📀', keywords: ['dvd', 'disc', 'movie', 'video', 'data'] },
    { emoji: '🧮', keywords: ['abacus', 'calculate', 'math', 'count', 'ancient'] },
    { emoji: '🎥', keywords: ['camera', 'movie', 'film', 'video', 'record'] },
    { emoji: '🎞️', keywords: ['film', 'frames', 'movie', 'cinema', 'strip'] },
    { emoji: '📽️', keywords: ['projector', 'film', 'movie', 'cinema', 'presentation'] },
    { emoji: '📺', keywords: ['tv', 'television', 'screen', 'watch', 'show'] },
    { emoji: '📷', keywords: ['camera', 'photo', 'picture', 'photography', 'snap'] },
    { emoji: '📸', keywords: ['camera', 'flash', 'photo', 'picture', 'snapshot'] },
    { emoji: '📹', keywords: ['video', 'camera', 'record', 'camcorder', 'film'] },
    { emoji: '📼', keywords: ['vhs', 'tape', 'video', 'cassette', 'retro'] },
    { emoji: '🔍', keywords: ['magnifying', 'glass', 'search', 'zoom', 'find'] },
    { emoji: '🔎', keywords: ['magnifying', 'glass', 'search', 'zoom', 'find'] },
    { emoji: '🕯️', keywords: ['candle', 'light', 'flame', 'wax', 'romantic'] },
    { emoji: '💡', keywords: ['lightbulb', 'idea', 'light', 'bright', 'think'] },
    { emoji: '🔦', keywords: ['flashlight', 'torch', 'light', 'dark', 'beam'] },
    { emoji: '🏮', keywords: ['lantern', 'red', 'paper', 'japanese', 'light'] },
    { emoji: '🪔', keywords: ['lamp', 'diya', 'oil', 'light', 'diwali'] },
    { emoji: '📔', keywords: ['notebook', 'decorative', 'cover', 'journal', 'book'] },
    { emoji: '📕', keywords: ['book', 'closed', 'red', 'read', 'cover'] },
    { emoji: '📖', keywords: ['book', 'open', 'read', 'pages', 'study'] },
    { emoji: '📗', keywords: ['book', 'green', 'read', 'cover', 'study'] },
    { emoji: '📘', keywords: ['book', 'blue', 'read', 'cover', 'study'] },
    { emoji: '📙', keywords: ['book', 'orange', 'read', 'cover', 'study'] },
    { emoji: '📚', keywords: ['books', 'library', 'read', 'study', 'stack'] },
    { emoji: '📓', keywords: ['notebook', 'journal', 'write', 'notes', 'diary'] },
    { emoji: '📒', keywords: ['ledger', 'notebook', 'notes', 'journal', 'yellow'] },
    { emoji: '📃', keywords: ['page', 'curl', 'document', 'paper', 'scroll'] },
    { emoji: '📜', keywords: ['scroll', 'paper', 'ancient', 'document', 'parchment'] },
    { emoji: '📄', keywords: ['page', 'document', 'paper', 'file', 'facing'] },
    { emoji: '📰', keywords: ['newspaper', 'news', 'paper', 'press', 'article'] },
    { emoji: '🗞️', keywords: ['newspaper', 'rolled', 'news', 'paper', 'press'] },
    { emoji: '📑', keywords: ['bookmark', 'tabs', 'marker', 'page', 'document'] },
    { emoji: '🔖', keywords: ['bookmark', 'mark', 'page', 'save', 'tag'] },
    { emoji: '🏷️', keywords: ['label', 'tag', 'price', 'sale', 'mark'] },
    { emoji: '💰', keywords: ['money', 'bag', 'dollar', 'rich', 'cash'] },
    { emoji: '🪙', keywords: ['coin', 'money', 'gold', 'currency', 'cash'] },
    { emoji: '💴', keywords: ['yen', 'money', 'japanese', 'currency', 'cash'] },
    { emoji: '💵', keywords: ['dollar', 'money', 'cash', 'bill', 'currency'] },
    { emoji: '💶', keywords: ['euro', 'money', 'currency', 'cash', 'bill'] },
    { emoji: '💷', keywords: ['pound', 'money', 'british', 'currency', 'cash'] },
    { emoji: '💸', keywords: ['money', 'wings', 'flying', 'spend', 'waste'] },
    { emoji: '💳', keywords: ['credit', 'card', 'payment', 'money', 'debit'] },
    { emoji: '🧾', keywords: ['receipt', 'bill', 'payment', 'purchase', 'proof'] },
    { emoji: '💹', keywords: ['chart', 'stock', 'market', 'graph', 'increase'] },
    { emoji: '✉️', keywords: ['envelope', 'mail', 'letter', 'email', 'message'] },
    { emoji: '📧', keywords: ['email', 'e-mail', 'letter', 'message', 'inbox'] },
    { emoji: '📨', keywords: ['envelope', 'incoming', 'mail', 'letter', 'receive'] },
    { emoji: '📩', keywords: ['envelope', 'arrow', 'mail', 'send', 'outgoing'] },
    { emoji: '📤', keywords: ['outbox', 'tray', 'send', 'mail', 'upload'] },
    { emoji: '📥', keywords: ['inbox', 'tray', 'receive', 'mail', 'download'] },
    { emoji: '📦', keywords: ['package', 'box', 'delivery', 'shipping', 'parcel'] },
    { emoji: '📫', keywords: ['mailbox', 'closed', 'flag', 'mail', 'letter'] },
    { emoji: '📪', keywords: ['mailbox', 'closed', 'lowered', 'mail', 'empty'] },
    { emoji: '📬', keywords: ['mailbox', 'open', 'raised', 'mail', 'letter'] },
    { emoji: '📭', keywords: ['mailbox', 'open', 'lowered', 'mail', 'empty'] },
    { emoji: '📮', keywords: ['postbox', 'mail', 'letter', 'send', 'red'] },
    { emoji: '🗳️', keywords: ['ballot', 'box', 'vote', 'election', 'poll'] },
    { emoji: '✏️', keywords: ['pencil', 'write', 'draw', 'edit', 'school'] },
    { emoji: '✒️', keywords: ['pen', 'nib', 'write', 'black', 'ink'] },
    { emoji: '🖋️', keywords: ['pen', 'fountain', 'write', 'ink', 'fancy'] },
    { emoji: '🖊️', keywords: ['pen', 'ballpoint', 'write', 'ink', 'office'] },
    { emoji: '🖌️', keywords: ['paintbrush', 'art', 'paint', 'brush', 'draw'] },
    { emoji: '🖍️', keywords: ['crayon', 'draw', 'color', 'art', 'kids'] },
    { emoji: '📝', keywords: ['memo', 'note', 'write', 'pencil', 'document'] },
    { emoji: '💼', keywords: ['briefcase', 'work', 'business', 'office', 'job'] },
    { emoji: '📁', keywords: ['folder', 'file', 'directory', 'organize', 'documents'] },
    { emoji: '📂', keywords: ['folder', 'open', 'file', 'directory', 'documents'] },
    { emoji: '🗂️', keywords: ['dividers', 'index', 'card', 'organize', 'tabs'] },
    { emoji: '📅', keywords: ['calendar', 'date', 'schedule', 'event', 'day'] },
    { emoji: '📆', keywords: ['calendar', 'tear', 'off', 'date', 'schedule'] },
    { emoji: '🗒️', keywords: ['notepad', 'spiral', 'note', 'pad', 'write'] },
    { emoji: '🗓️', keywords: ['calendar', 'spiral', 'date', 'schedule', 'planner'] },
    { emoji: '📇', keywords: ['card', 'index', 'rolodex', 'contacts', 'organize'] },
    { emoji: '📈', keywords: ['chart', 'increasing', 'graph', 'growth', 'up'] },
    { emoji: '📉', keywords: ['chart', 'decreasing', 'graph', 'down', 'loss'] },
    { emoji: '📊', keywords: ['chart', 'bar', 'graph', 'statistics', 'data'] },
    { emoji: '📋', keywords: ['clipboard', 'list', 'document', 'paste', 'notes'] },
    { emoji: '📌', keywords: ['pushpin', 'pin', 'location', 'mark', 'tack'] },
    { emoji: '📍', keywords: ['pin', 'round', 'pushpin', 'location', 'mark'] },
    { emoji: '📎', keywords: ['paperclip', 'clip', 'attach', 'office', 'documents'] },
    { emoji: '🖇️', keywords: ['paperclips', 'linked', 'attach', 'office', 'chain'] },
    { emoji: '📏', keywords: ['ruler', 'straight', 'measure', 'length', 'edge'] },
    { emoji: '📐', keywords: ['ruler', 'triangular', 'set', 'square', 'measure'] },
    { emoji: '✂️', keywords: ['scissors', 'cut', 'snip', 'craft', 'trim'] },
    { emoji: '🗃️', keywords: ['card', 'file', 'box', 'organize', 'storage'] },
    { emoji: '🗄️', keywords: ['cabinet', 'file', 'filing', 'office', 'storage'] },
    { emoji: '🗑️', keywords: ['trash', 'bin', 'wastebasket', 'delete', 'garbage'] },
    { emoji: '🔒', keywords: ['lock', 'locked', 'secure', 'closed', 'padlock'] },
    { emoji: '🔓', keywords: ['unlock', 'unlocked', 'open', 'padlock', 'security'] },
    { emoji: '🔏', keywords: ['lock', 'pen', 'ink', 'privacy', 'secure'] },
    { emoji: '🔐', keywords: ['lock', 'key', 'closed', 'secure', 'password'] },
    { emoji: '🔑', keywords: ['key', 'lock', 'password', 'unlock', 'access'] },
    { emoji: '🗝️', keywords: ['key', 'old', 'antique', 'skeleton', 'vintage'] },
    { emoji: '🔨', keywords: ['hammer', 'tool', 'build', 'nail', 'construction'] },
    { emoji: '🪓', keywords: ['axe', 'chop', 'wood', 'tool', 'lumberjack'] },
    { emoji: '⛏️', keywords: ['pick', 'mining', 'dig', 'tool', 'minecraft'] },
    { emoji: '⚒️', keywords: ['hammer', 'pick', 'tool', 'mining', 'work'] },
    { emoji: '🛠️', keywords: ['tools', 'hammer', 'wrench', 'fix', 'repair'] },
    { emoji: '🗡️', keywords: ['dagger', 'knife', 'sword', 'weapon', 'blade'] },
    { emoji: '⚔️', keywords: ['swords', 'crossed', 'battle', 'fight', 'weapon'] },
    { emoji: '🔫', keywords: ['gun', 'pistol', 'water', 'toy', 'weapon'] },
    { emoji: '🛡️', keywords: ['shield', 'protect', 'defense', 'security', 'armor'] },
    { emoji: '🪚', keywords: ['saw', 'carpentry', 'tool', 'cut', 'wood'] },
    { emoji: '🔧', keywords: ['wrench', 'tool', 'fix', 'repair', 'spanner'] },
    { emoji: '🪛', keywords: ['screwdriver', 'tool', 'fix', 'repair', 'screw'] },
    { emoji: '🔩', keywords: ['nut', 'bolt', 'screw', 'hardware', 'tool'] },
    { emoji: '⚙️', keywords: ['gear', 'cog', 'settings', 'mechanical', 'engine'] },
    { emoji: '🗜️', keywords: ['clamp', 'compress', 'tool', 'vice', 'grip'] },
    { emoji: '⚖️', keywords: ['scale', 'balance', 'justice', 'law', 'weigh'] },
    { emoji: '🦯', keywords: ['cane', 'probing', 'blind', 'accessibility', 'white'] },
    { emoji: '🔗', keywords: ['link', 'chain', 'connect', 'url', 'hyperlink'] },
    { emoji: '⛓️', keywords: ['chains', 'link', 'metal', 'bound', 'connect'] },
    { emoji: '🧰', keywords: ['toolbox', 'tools', 'mechanic', 'fix', 'repair'] },
    { emoji: '🧲', keywords: ['magnet', 'attract', 'magnetic', 'horseshoe', 'pull'] },
    { emoji: '🪜', keywords: ['ladder', 'climb', 'step', 'up', 'tool'] },
    { emoji: '⚗️', keywords: ['alembic', 'chemistry', 'science', 'lab', 'experiment'] },
    { emoji: '🧪', keywords: ['test', 'tube', 'science', 'lab', 'chemistry'] },
    { emoji: '🧫', keywords: ['petri', 'dish', 'science', 'lab', 'bacteria'] },
    { emoji: '🧬', keywords: ['dna', 'gene', 'genetics', 'science', 'biology'] },
    { emoji: '🔬', keywords: ['microscope', 'science', 'lab', 'biology', 'research'] },
    { emoji: '🔭', keywords: ['telescope', 'astronomy', 'space', 'stars', 'science'] },
    { emoji: '📡', keywords: ['satellite', 'antenna', 'dish', 'signal', 'communication'] },
    { emoji: '💉', keywords: ['syringe', 'needle', 'injection', 'vaccine', 'medical'] },
    { emoji: '💊', keywords: ['pill', 'medicine', 'drug', 'capsule', 'health'] },
    { emoji: '🩹', keywords: ['bandage', 'adhesive', 'bandaid', 'injury', 'medical'] },
    { emoji: '🩺', keywords: ['stethoscope', 'doctor', 'medical', 'health', 'heart'] },
  ],
};

export default objects;

